import { render, staticRenderFns } from "./ConfirmApproveDialog.vue?vue&type=template&id=8986a638&scoped=true"
import script from "./ConfirmApproveDialog.vue?vue&type=script&lang=ts"
export * from "./ConfirmApproveDialog.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmApproveDialog.vue?vue&type=style&index=0&id=8986a638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8986a638",
  null
  
)

export default component.exports